<template>
  <v-card :loading="loading" :outlined="false">
    <v-alert v-if="erros" type="erros">{{ erros }}</v-alert>

    <v-container>
      <v-form ref="formAtendimento">
        <v-container>
          <v-row>
            <v-textarea
              class="my-0 py-0"
              rows="3"
              autocomplete="nope"
              outlined
              label="Observação"
              placeholder="Descreva algo para se lembrar!"
              v-model="$v.formAtendimento.ds_observacao.$model"
              :error-messages="
                validacaoForm($v.formAtendimento.ds_observacao, 'Observação')
              "
            ></v-textarea>

            <v-btn
              full-width="false"
              color="success"
              class="ma-2 d-flex align-self-center"
              @click="gravar()"
              :loading="loading"
            >
              Adicionar
            </v-btn>
          </v-row>
        </v-container>
      </v-form>

      <material-card
        color="success"
        title="Histórico das observações"
        text
        :isbutton="true"
      >
        <v-row v-for="item in atendimentos" :key="item.id">
          <v-card elevation="2" class="pa-3 my-2" outlined width="100%">
            <v-row>
              <v-col>
                <h4 class="font-weight-black">
                  {{ item.nm_colaborador }}
                </h4>
              </v-col>
              <v-col class="d-flex justify-end" cols="2">
                <v-tooltip top dark color="success darken-4">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      dark
                      fab
                      color="success"
                      x-small
                      @click="deletarItem(item)"
                      v-if="permitirExcluirObservacao()"
                    >
                      <v-icon style="font-size: 14px">mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <span class="white--text text--darken-1 subtitle-2">Excluir</span>
                </v-tooltip>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">             
                <h4 class="font-weight-black">
                  {{
                    item.dt_atendimento
                      ? converteDataHoraParaView(item.dt_atendimento)
                      : null
                  }}
                </h4>
              </v-col>
              <v-col cols="12">
                <h4 class="font-weight-regular">
                  <v-divider class="pb-3" />
                  {{ item.ds_observacao }}
                </h4>
              <!-- </v-col>
              <v-col cols="1"> -->
                
              </v-col>
            </v-row>
          </v-card>
        </v-row>
      </material-card>
    </v-container>
  </v-card>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { mapGetters, mapActions, mapState, mapMutations } from "vuex";
import validacaoForm from "@/mixins/validacaoForm";
import utils from "@/mixins/utils";
import validaUsuario from '@/utils/privilegiosUsuario'


export default {
  name: "Observacao",
  props: ["processo_id"],
  mixins: [utils, validacaoForm],

  components: {},

  data() {
    return {
      loading: false,
      dialog: false,
      formAtendimento: {
        id: "",
        dt_atendimento: "",
        ds_observacao: "",
        processo_id: "",
      },
      atendimento: {},
    };
  },

  validations: {
    formAtendimento: {
      ds_observacao: { required, errors: [] },
    },
  },

  async created() {
    await this.carregaDadosNaTela();
    this.resetErros();
  },

  methods: {
    ...mapActions({
      actBuscaAtendimentos: "atendimento/GET_ATENDIMENTOSPORPROCESSO",
      actStoreAtendimento: "atendimento/STORE_ATENDIMENTO",
      actAtedimentoReset: "atendimento/RESET_SELECTED",
      actAtendimentoNovo: "atendimento/ATENDIMENTO_SELECTED",
      actAtendimentoDelete: "atendimento/DELETE_ATENDIMENTO",
    }),

    ...mapMutations({
      commitErro: "atendimento/SET_ERROS",
      resetErros: "atendimento/ERASE_ERROS",
      setStateButton: 'processo/SET_STATE_BUTTON'
    }),

    ...mapGetters({
      getErros: "atendimento/GET_ERROS",
    }),

    permitirExcluirObservacao() {
      return validaUsuario.ehUsuarioAdministrador()
    },

    async carregaDadosNaTela() {
      this.loading = true
      this.$v.formAtendimento.$reset();
      this.formAtendimento = Object.assign(
        {},
        {
          id: "",
          dt_atendimento: "",
          ds_observacao: "",
          processo_id: "",
        }
      );
      this.formAtendimento.dt_atendimento = this.converteDataHoraParaView(this.formAtendimento.dt_atendimento)
      await this.buscarAtendimentos();
      this.loading = false
    },

    deletarItem (item) {
      this.$dialog.confirm("Deseja realmente excluir. Deseja continuar?", {loader: true, okText: 'Sim', cancelText: 'Não',})
      .then(async (dialog) => {
        try {
          await this.actAtendimentoDelete(item)
          this.$toaster.success('Observação Excluído!');
        } catch (e) {
          this.commitErro({ erros: "Erro ao enviar dados para Api 'actAtendimentoDelete'" })
          this.$toaster.error('Erro ao excluir!');
        } finally {
          dialog.close();
        }
      })
      .catch((e) => {
        //this.$toaster.error('Exclusão de Colaborador Cancelada!');
      })
    },

    async buscarAtendimentos() {
      try {
        await this.actBuscaAtendimentos(this.processo_id);        
      } catch (error) {
        console.log('Error buscarAtendimentos()', error)
      } finally {
        this.loading = false
      }
    },

    validaForm() {
      this.$v.formAtendimento.$touch();
      if (!this.$v.formAtendimento.$invalid) {
        return true;
      } else if (this.$v.formAtendimento.$anyError) {
        return false;
      }
    },

    async gravar() {
      this.resetErros();
      this.loading = true;
      if (!(await this.validaForm())) {
        this.$toaster.error("Erro ao gravar!");
        this.loading = false;
        return;
      }

      if (!(await this.store())) {
        this.$toaster.error("Erro ao gravar!");
        this.loading = false
        return;
      }
      this.$toaster.success("Gravação efetuada com sucesso!");
      this.carregaDadosNaTela();
      this.loading = false
    },

    async store() {
      try {
        this.atendimento = Object.assign({}, this.criaObjetoGravar());
        await this.actStoreAtendimento(this.atendimento);
        if (this.erros) {
          return false;
        }
        return true;
      } catch (error) {
        this.commitErro({ erros: "Erro ao enviar dados para Api 'store'" });
        return false;
      } finally {
        this.loading = false;
      }
    },

    criaObjetoGravar() {
      return {
        id: this.formAtendimento.id ? this.formAtendimento.id : "",
        dt_atendimento: this.converteDataHoraParaApi(this.$moment()),
        ds_observacao: this.formAtendimento.ds_observacao,
        processo_id: this.processo_id,
      };
    },
  },

  computed: {
    ...mapState("atendimento", [
      "atendimentoSelecionado", 
      "erros"
    ]),
    ...mapState('processo', [
      'loadingStore'
    ]),
    ...mapGetters({
      getAtendimentosDoProcesso: "atendimento/GET_ATENDIMENTOSPORPROCESSO",
    }),

    atendimentos: function () {
      return Object.assign({}, this.getAtendimentosDoProcesso)
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/Processo/Observacao.vue